export type Avatar = {
  fullName: string;
  color?: string;
};

export { Sizes } from "@slhuicore/avatar";

export enum SizeValues {
  SM = <number>24,
  MD = <number>40,
  LG = <number>64,
  XL = <number>120,
}
